import { api } from './client';
import type { Schedule, ScheduleCreate } from '@/types';

export function listSchedules(): Promise<Schedule[]> {
  return api<Schedule[]>('/api/schedules');
}

export function createSchedule(body: ScheduleCreate): Promise<Schedule> {
  return api<Schedule>('/api/schedules', { method: 'POST', body });
}

export function updateSchedule(id: string, body: Partial<ScheduleCreate>): Promise<Schedule> {
  return api<Schedule>(`/api/schedules/${id}`, { method: 'PUT', body });
}

export function deleteSchedule(id: string): Promise<void> {
  return api<void>(`/api/schedules/${id}`, { method: 'DELETE' });
}
